/** localStorage-backed recent queries, keyed by userId. */

const KEY = (uid: string) => `askbot-recent-${uid}`;
const MAX = 10;

export function getRecentQueries(userId: string): string[] {
  try {
    const raw = localStorage.getItem(KEY(userId));
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function addRecentQuery(userId: string, query: string): void {
  const prev = getRecentQueries(userId).filter((q) => q !== query);
  try {
    localStorage.setItem(KEY(userId), JSON.stringify([query, ...prev].slice(0, MAX)));
  } catch { /* quota exceeded — silently skip */ }
}

export function clearRecentQueries(userId: string): void {
  try { localStorage.removeItem(KEY(userId)); } catch { /* no-op */ }
}
